import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index";
import { validAdministracion, validCharter, validLineas, validServicioIntegral, validSuperAdmin, validSIFinanzas, validShipping } from '../mixins';

// Vuex
// import store from "@/store/index";

Vue.use(VueRouter);

/**
 * @author Miguel González.
 * @description add beforeEnter to prevent url inserts. 
 * last modified 26-04-2023 12:25 */
const roleStructure = JSON.parse(localStorage.getItem('roleStructure'));
const userStructure = JSON.parse(localStorage.getItem('userStructure'));

const validAdministracionRouter = validAdministracion(roleStructure, userStructure);
const validCharterRouter = validCharter(roleStructure, userStructure);
const validLineasRouter = validLineas(roleStructure, userStructure);
const validServicioIntegralRouter = validServicioIntegral(roleStructure, userStructure);
const validSuperAdminRouter = validSuperAdmin(roleStructure, userStructure);
const validSIFinanzasRouter = validSIFinanzas(roleStructure, userStructure);
const validShippingRouter = validShipping(roleStructure, userStructure);

let routes = [];

routes = [
  {
    path: "/",
    component: Index,
    children: [
      // Pagina principal
      {
        path: "/",
        name: "dashboard",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/Dashboard"),
      },

      /* ...::: Super Administración :::... */

      // Filiales
      {
        path: "superadministrador/filiales",
        name: "filiales",
        beforeEnter: (to, from, next) => (!validSuperAdminRouter.showFiliales ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "filiales" */ "../views/administracion/FilialesPage"
          ),
      },

      // Mantenedor regional
      {
        path: "superadministrador/mantenedor_regional",
        name: "mantenedor_regional",
        beforeEnter: (to, from, next) => (!validSuperAdminRouter.showMantenedorRegional ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "mantenedor_regional" */ "../views/administracion/MantenedorRegionalPage"
          ),
      },

      // Modulos
      {
        path: "superadministrador/modulos",
        name: "modulos",
        beforeEnter: (to, from, next) => (!validSuperAdminRouter.showModulos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "modulos" */ "../views/superadministrador/ModulosPage"
          ),
      },

      // Roles
      {
        path: "superadministrador/roles",
        name: "roles",
        beforeEnter: (to, from, next) => (!validSuperAdminRouter.showRoles ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "roles" */ "../views/administracion/RolesPage"
          ),
      },

      // Secciones
      {
        path: "superadministrador/secciones",
        name: "secciones",
        beforeEnter: (to, from, next) => (!validSuperAdminRouter.showSecciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "secciones" */ "../views/superadministrador/SeccionesPage"
          ),
      },
      /* ...::: Administración :::... */
      // Clientes
      {
        path: "administracion/clientes",
        name: "clientes",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showEmpresas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "clientes" */ "../views/administracion/ClientesPage"
          ),
      },

      // Usuarios
      {
        path: "administracion/perfil_usuario",
        name: "perfil",
        beforeEnter: (to, from, next) => (next()),
        component: () =>
          import(
            /* webpackChunkName: "usuarios" */ "../views/administracion/PerfilUsuario"
          ),
      },

      // Usuarios
      {
        path: "administracion/usuarios",
        name: "usuarios",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showUsuarios ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "usuarios" */ "../views/administracion/UsuariosPage"
          ),
      },

      // Proveedores
      {
        path: "administracion/proveedores",
        name: "proveedores",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showProveedores ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "proveedores" */ "../views/administracion/ProveedoresPage"
          ),
      },



      // Puertos
      {
        path: "administracion/puertos",
        name: "puertos",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showPuertos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "puertos" */ "../views/administracion/PuertosPage"
          ),
      },

      // Destinos
      {
        path: "administracion/destinos",
        name: "destinos",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showDestinos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "destinos" */ "../views/administracion/DestinosPage"
          ),
      },

      /* Sub Menu para contenedores */
      // Contenedores -> Contenedores
      {
        path: "administracion/contenedores",
        name: "contenedores",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showSubContenedores ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "contenedores" */ "../views/administracion/ContenedoresPage"
          ),
      },

      // Contenedores -> Depositos
      {
        path: "administracion/depositos",
        name: "depositos",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showDepositos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "depositos" */ "../views/administracion/contenedores/DepositosTabPage"
          ),
      },

      // Contenedores -> Atmosferas
      {
        path: "administracion/atmosferas",
        name: "atmosferas",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showAtmosferas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "atmosferas" */ "../views/administracion/contenedores/AtmosferasTabPage"
          ),
      },

      // Contenedores -> Tipos de movimientos
      {
        path: "administracion/tipos_de_movimiento",
        name: "tiposMovimiento",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showTiposDeMovimiento ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "tipos_de_movimiento" */ "../views/administracion/contenedores/TiposMovimientoTabPage"
          ),
      },

      // Contenedores -> Atmosferas
      {
        path: "administracion/zonas_de_consolidacion",
        name: "zonasConsolidacion",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showZonasDeConsolidacion ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "zonas_de_consolidacion" */ "../views/administracion/contenedores/ZonasConsolidacionTabPage"
          ),
      },

      // Pallets
      {
        path: "administracion/pallets",
        name: "pallets",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showPallets ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "pallets" */ "../views/administracion/PalletsPage"
          ),
      },

      // Condiciones
      {
        path: "administracion/condiciones",
        name: "condiciones",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showCondiciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "condiciones" */ "../views/administracion/CondicionesPage"
          ),
      },

      // Naves
      {
        path: "administracion/naves",
        name: "naves",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showNaves ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "naves" */ "../views/administracion/NavesPage"
          ),
      },

      // Navieras
      {
        path: "administracion/navieras",
        name: "navieras",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showNavieras ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "navieras" */ "../views/administracion/NavierasPage"
          ),
      },

      // Productos
      {
        path: "administracion/categorias_productos",
        name: "categorias-productos",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showCategoriaProductos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "productos" */ "../views/administracion/ProductosPage"
          ),
      },

      // Limite Planificaciones
      {
        path: "administracion/tiempo_limite_de_planificaciones",
        name: "limitePlanificaiones",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showLimitePlanificaciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "tiempo_limite_de_planificaciones" */ "../views/administracion/LimitePlanificacionesPage"
          ),
      },

      // Temporadas
      {
        path: "administracion/temporadas",
        name: "temporadas",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showTemporadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "temporadas" */ "../views/administracion/TemporadasPage"
          ),
      },

      // Embarcador
      {
        path: "administracion/embarcadores",
        name: "embarcador",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showEmbarcador ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "embarcadores" */ "../views/administracion/EmbarcadorPage"
          ),
      },

      /* Extra costos / Recargos */

      // Tipos de extra costos
      {
        path: "administracion/tipos_de_extra_costos",
        name: "tiposExtraCostos",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showEmbarcador ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "tiposExtraCostos" */ "../views/administracion/TiposExtraCostosPage"
          ),
      },

      /* Adm. Tiers */

      // Tipos de extra costos
      {
        path: "administracion/tiers",
        name: "tiposExtraCostos",
        beforeEnter: (to, from, next) => (!validAdministracionRouter.showEmbarcador ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "tiposExtraCostos" */ "../views/administracion/TiersAdminPage"
          ),
      },

      /*
          ...::: Charter :::... 
        */
      // Planificacion Anual
      {
        path: "charter/planificacion_anual",
        name: "planificacion-anual",
        beforeEnter: (to, from, next) => (!validCharterRouter.showPlanificacionAnual ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "planificacion_anual" */ "../views/charter/PlanificacionAnualPage"
          ),
      },

      // Planificacion Anual
      {
        path: "charter/planificacion_semanal",
        name: "planificacion-semanal",
        beforeEnter: (to, from, next) => (!validCharterRouter.showPlanificacionSemanal ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "planificacion_semanal" */ "../views/charter/PlanificacionSemanalPage"
          ),
      },

      // Servicios
      {
        path: "charter/servicios",
        name: "charter-servicios",
        beforeEnter: (to, from, next) => (!validCharterRouter.showServicios ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "servicios" */ "../views/charter/ServiciosCharterPage"
          ),
      },

      // Declaración por nave
      {
        path: "charter/declaracion_por_nave",
        name: "declaracionPorNave",
        beforeEnter: (to, from, next) => (!validCharterRouter.showDeclaracionPorNave ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "declaracion_por_nave" */ "../views/charter/DeclaracionPorNavePage"
          ),
      },

      // General
      {
        path: "charter/general",
        name: "charter-general",
        beforeEnter: (to, from, next) => (!validCharterRouter.showGeneral ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "general" */ "../views/charter/GeneralPage"
          ),
      },

      // Itinerarios
      {
        path: "charter/itinerarios",
        name: "charter-itinerarios",
        beforeEnter: (to, from, next) => (!validCharterRouter.showSubItinerarios ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "itinerarios" */ "../views/charter/ItinerariosPage"
          ),
      },

      {
        path: "/charter/si/por-enviar",
        name: "charter-si-por-enviar",
        beforeEnter: (to, from, next) => (!validCharterRouter.showPorEnviar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "itinerarios" */ "../views/charter/si/SiPorEnviarPage"
          ),
      },

      {
        path: "/charter/si/enviadas",
        name: "charter-si-enviadas",
        beforeEnter: (to, from, next) => (!validCharterRouter.showEnviadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "itinerarios" */ "../views/charter/si/SIEnviadasPage"
          ),
      },

      {
        path: "/charter/si/templates",
        name: "charter-si-templates",
        beforeEnter: (to, from, next) => (!validCharterRouter.showTemplates ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "itinerarios" */ "../views/charter/si/SITemplatesPage.vue"
          ),
      },

      {
        path: "/charter/reporte-general-charter",
        name: "reporte-general-charter",
        beforeEnter: (to, from, next) => (!validCharterRouter.showEnviadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "itinerarios" */ "../views/charter/ReportePage"
          ),
      },

      /* validLineasRouter
        ...::: Líneas :::... */

      // Buscar BL
      {
        path: "lineas/buscar_bl",
        name: "buscarBL",
        beforeEnter: (to, from, next) => (!validLineasRouter.showBuscarBL ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "buscar_bl" */ "../views/lineas/BuscarBLPage"
          ),
      },

      // Planificación Anual
      {
        path: "lineas/planificacion_anual",
        name: "planificacionAnual",
        beforeEnter: (to, from, next) => (!validLineasRouter.showPlanificacionAnual ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "planificacion_anual" */ "../views/lineas/PlanAnualPage"
          ),
      },

      // Planificación Semanal
      {
        path: "lineas/planificacion_semanal",
        name: "planificacionSemanal",
        beforeEnter: (to, from, next) => (!validLineasRouter.showPlanificacionSemanal ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "planificacion_semanal" */ "../views/lineas/PlanSemanalPage"
          ),
      },

      // Servicios
      {
        path: "lineas/servicios",
        name: "servicios",
        beforeEnter: (to, from, next) => (!validLineasRouter.showServicios ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/ServiciosPage"
          ),
      },

      // Booking no Planificado
      // {
      //   path: "lineas/booking/booking_no_planificado",
      //   name: "bookingNoPlanificado",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "about" */ "../views/lineas/booking/BookingNoPlanificadoPage"
      //     ),
      // },

      // Bookings Declarados
      {
        path: "lineas/booking/bookings_declarados",
        name: "bookingsDeclarados",
        beforeEnter: (to, from, next) => (!validLineasRouter.showBookingsDeclarados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/BookingsDeclaradosPage"
          ),
      },

      // Bookings Solicitados
      {
        path: "lineas/booking/bookings_solicitados",
        name: "bookingsSolicitados",
        beforeEnter: (to, from, next) => (!validLineasRouter.showBookingsSolicitados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/BookingsSolicitadosPage"
          ),
      },

      // Bookings Confirmados
      {
        path: "lineas/booking/bookings_confirmados",
        name: "bookingsConfirmados",
        beforeEnter: (to, from, next) => (!validLineasRouter.showBookingsConfirmados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/BookingsConfirmadosPage"
          ),
      },

      // Bookings Solicitudes Modificación
      {
        path: "lineas/booking/solicitudes_modificacion",
        name: "solicitudesModificacion",
        beforeEnter: (to, from, next) => (!validLineasRouter.showSolicitudesModificacion ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/BookingsSolicitudesModificacionPage"
          ),
      },

      // Bookings Embarcados
      {
        path: "lineas/booking/bookings_embarcados",
        name: "bookingsEmbarcados",
        beforeEnter: (to, from, next) => (!validLineasRouter.showBookingsEmbarcados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/BookingsEmbarcadosPage"
          ),
      },

      // Bookings Late Arrivals
      {
        path: "lineas/booking/late_arrivals",
        name: "lateArrivals",
        beforeEnter: (to, from, next) => (!validLineasRouter.showLateArrivals ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/BookingsLateArrivalsPage"
          ),
      },

      // Bookings Cancelados
      {
        path: "lineas/booking/bookings_cancelados",
        name: "bookingsCancelados",
        beforeEnter: (to, from, next) => (!validLineasRouter.showBookingsCancelados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/BookingsCanceladosPage"
          ),
      },

      // Ver Bookings declarados cancelados
      {
        path: "lineas/booking/ver_Bookings_declarados_cancelados",
        name: "verBookingsDeclaradosCancelados",
        beforeEnter: (to, from, next) => (!validLineasRouter.showDeclaradosCancelados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/booking/VerBookingsDeclaradosCanceladosPage"
          ),
      },

      // Ver Bookings por aceptar
      {
        path: "lineas/booking/ver_bookings_por_aceptar",
        name: "verBookingPorAceptar",
        beforeEnter: (to, from, next) => (!validLineasRouter.showMisBookingsPorAceptar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "verBookingPorAceptar" */ "../views/lineas/booking/VerMisBookingPorAceptarPage"
          ),
      },

      // Ver Bookings por aceptar
      {
        path: "lineas/booking/bookings_por_confirmar",
        name: "bookingsPorConfirmar",
        beforeEnter: (to, from, next) => (!validLineasRouter.showBookingsPorConfirmar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "verBookingPorAceptar" */ "../views/lineas/booking/BookingsPorConfirmarPage"
          ),
      },




      // General
      {
        path: "lineas/general_lineas",
        name: "general",
        beforeEnter: (to, from, next) => (!validLineasRouter.showGeneral ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "GeneralLineasPage" */ "../views/lineas/GeneralLineasPage"
          ),
      },

      // General Extra Costos
      {
        path: "lineas/general_extra_costos",
        name: "general_extra_costos",
        beforeEnter: (to, from, next) => (!validLineasRouter.showGeneral ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/GeneralLineasExtraCostosPage"
          ),
      },

      /* 
         
         
  
  
         Sub Menu => Tarifas
         */

      // Contratos
      {
        path: "lineas/tarifas/contratos",
        name: "contratos",
        beforeEnter: (to, from, next) => (!validLineasRouter.showTarifas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/tarifas/ContratosPage"
          ),
      },

      //  Acuerdos Líneas
      {
        path: "lineas/tarifas/acuerdos_lineas",
        name: "acuerdosLineas",
        beforeEnter: (to, from, next) => (!validLineasRouter.showAcuerdosLineas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "acuerdos_lineas" */ "../views/lineas/tarifas/AcuerdosLineasPage"
          ),
      },

      // Acuerdos Clientes Base
      {
        path: "lineas/tarifas/acuerdos_clientes_base",
        name: "acuerdosClientesBase",
        beforeEnter: (to, from, next) => (!validLineasRouter.showAcuerdosClientesBase ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "acuerdos_clientes_base" */ "../views/lineas/tarifas/AcuerdosClientesBasePage"
          ),
      },

      // Acuerdos Clientes
      {
        path: "lineas/tarifas/acuerdos_clientes",
        name: "acuerdosClientes",
        beforeEnter: (to, from, next) => (!validLineasRouter.showAcuerdosClientes ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "acuerdos_clientes" */ "../views/lineas/tarifas/AcuerdosClientesPage"
          ),
      },

      // Tarifas Líneas
      {
        path: "lineas/tarifas/tarifas_lineas",
        name: "tarifasLineas",
        beforeEnter: (to, from, next) => (!validLineasRouter.showTarifasLineas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "tarifas_lineas" */ "../views/lineas/tarifas/TarifasLineasPage"
          ),
      },

      // Descuentos Clientes
      {
        path: "lineas/tarifas/descuentos_clientes",
        name: "descuentosClientes",
        beforeEnter: (to, from, next) => (!validLineasRouter.showDescuentosClientes ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "descuentos_clientes" */ "../views/lineas/tarifas/DescuentosClientesPage"
          ),
      },

      // Reporte Tarifa Embarcador
      {
        path: "lineas/tarifas/reporte_finanzas",
        name: "reporteFinanzas",
        beforeEnter: (to, from, next) => (!validLineasRouter.showReporteTarifaEmbarcados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "reporte_tarifa_embarcador" */ "../views/lineas/tarifas/ReporteFinanzasPage.vue"
          ),
      },
      // Recargos
      {
        path: "lineas/tarifas/recargos",
        name: "mantenedorRecargos",
        beforeEnter: (to, from, next) => (!validLineasRouter.showRecargos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "reporte_tarifa_embarcador" */ "../views/lineas/tarifas/RecargosPage"
          ),
      },
      {
        path: "lineas/tarifas/importador_cotizaciones",
        name: "impCotizaciones",
        beforeEnter: (to, from, next) => (!validLineasRouter.showImportadorCotizaciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "reporte_tarifa_embarcador" */ "../views/lineas/tarifas/ImpCotizacionesPage"
          ),
      },
      // Itinerarios
      {
        path: "lineas/itinerarios",
        name: "itinerarios",
        beforeEnter: (to, from, next) => (!validLineasRouter.showItinerarios ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/ItinerariosPage"
          ),
      },

      // Buscar Itinerarios
      // {
      //   path: "lineas/itinerarios/buscar_itinerarios",
      //   name: "buscar_itinerarios",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "buscar_itinerarios" */ "../views/lineas/BuscarItinerariosPage"
      //     ),
      // },

      // Tracking
      {
        path: "lineas/tracking",
        name: "tracking",
        beforeEnter: (to, from, next) => (!validLineasRouter.showTracking ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/lineas/TrackingPage"
          ),
      },

      // SERVICIO INTEGRAL

      // tarifas

      // Tarifas Prov. Terrestres validServicioIntegralRouter
      {
        path: "servicio-integral/tarifas/tarifas_proveedores_terrestres",
        name: "tarifas_proveedores_terrestres",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasProveedoresTerrestre ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/tarifas/TarifasProvTerrestresPage"
          ),
      },

      // Tarifas Prov. Documentales
      {
        path: "servicio-integral/tarifas/tarifas_proveedores_documentales",
        name: "tarifa_proveedores_documentales",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasProveedoresDocumental ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/tarifas/TarifasProvDocumentalesPage"
          ),
      },

      // Tarifa Cliente Terrestre
      {
        path: "servicio-integral/tarifas/tarifa_cliente_terrestre",
        name: "tarifa_cliente_terrestre",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifaClienteTerrestre ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/tarifas/TarifaClienteTerrestrePage"
          ),
      },

      // Tarifa Cliente Documental
      {
        path: "servicio-integral/tarifas/tarifa_cliente_documental",
        name: "tarifa_cliente_documental",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifaClienteDocumental ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/tarifas/TarifaClienteDocumentalPage"
          ),
      },

      // Generar Propuesta Cliente
      {
        path: "servicio-integral/generar-propuesta-cliente/generar_propuesta",
        name: "generar_propuesta",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showGenerarPropuesta ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/generarpropuestacliente/GenerarPropuestaPage"
          ),
      },

      // instructivos de embarque

      // Booking
      {
        path: "servicio-integral/instructivos-de-embarque/bookings",
        name: "bookings_instructivos_embarque",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showInstructivosDeEmbarque ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/BookingsPage"
          ),
      },

      // Añadir I.E.
      {
        path: "servicio-integral/instructivos-de-embarque/anadir_i_e",
        name: "anadir_i_e",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showAnadirIE ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/AnadirIEPage"
          ),
      },

      // I.E. por Enviar
      {
        path: "servicio-integral/instructivos-de-embarque/i_e_por_enviar",
        name: "i_e_por_enviar",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showlEPorEnviar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/IEPorEnviarPage"
          ),
      },

      // I.E. Enviadas
      {
        path: "servicio-integral/instructivos-de-embarque/i_e_enviadas",
        name: "i_e_enviadas",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showIEEnviadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/IEEnviadasPage"
          ),
      },

      // I.E. Aceptadas
      {
        path: "servicio-integral/instructivos-de-embarque/i_e_aceptadas",
        name: "i_e_aceptadas",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showIEAceptadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/IEAceptadasPage"
          ),
      },

      // I.E. Rechazadas
      {
        path: "servicio-integral/instructivos-de-embarque/i_e_rechazadas",
        name: "i_e_rechazadas",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showIERechazadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/IERechazadasPage"
          ),
      },

      // Template
      {
        path: "servicio-integral/instructivos-de-embarque/template",
        name: "template",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTemplate ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/TemplatePage"
          ),
      },

      // Finalizadas
      {
        path: "servicio-integral/instructivos-de-embarque/finalizadas",
        name: "finalizadas",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showFinalizadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/instructivosembarque/FinalizadasPage"
          ),
      },

      // orden de servicio

      // Buscar OS
      {
        path: "servicio-integral/orden-de-servicio/buscar_os",
        name: "buscar_os",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showBuscarOS ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/BuscarOSPage"
          ),
      },

      // Por Asignar
      {
        path: "servicio-integral/orden-de-servicio/por_asignar",
        name: "por_asignar",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showPorAsignar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/PorAsignarPage"
          ),
      },

      // Asignadas
      {
        path: "servicio-integral/orden-de-servicio/asignadas",
        name: "asignadas",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showAsignadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/AsignadasPage"
          ),
      },

      // Retiro Contenedor
      {
        path: "servicio-integral/orden-de-servicio/retiro_contenedor",
        name: "retiro_contenedor",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showRetiroContenedor ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/RetiroContenedorPage"
          ),
      },

      // Carguío Planta / Entrega Matriz
      {
        path: "servicio-integral/orden-de-servicio/c_planta_e_matriz",
        name: "carga_planta_entrega_matriz",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showCargoPlantaEntregaMatriz ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/CarPlantaPage"
          ),
      },

      // Ingreso Puerto
      {
        path: "servicio-integral/orden-de-servicio/ingreso_puerto",
        name: "ingreso_puerto",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showIngresoPuerto ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/IngresoPuertoPage"
          ),
      },

      // Zarpe Masivo
      {
        path: "servicio-integral/orden-de-servicio/zarpe_masivo",
        name: "zarpe_masivo",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showZarpeMasivo ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/ZarpeMasivoPage"
          ),
      },

      // Agregar Factura
      {
        path: "servicio-integral/orden-de-servicio/agregar_factura",
        name: "agregar_factura",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showAgregarFactura ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/AgregarFacturaPage"
          ),
      },

      // Despacho Documentación
      {
        path: "servicio-integral/orden-de-servicio/despacho_documentacion",
        name: "despacho_documentacion",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showDespachoDocumentación ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/DespachoDocumentacionPage"
          ),
      },

      // Legalización DUS
      {
        path: "servicio-integral/orden-de-servicio/legalizacion_dus",
        name: "legalizacion_dus",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showLegalizacionDUS ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/LegalizacionDUSPage"
          ),
      },

      // Extra Costos
      {
        path: "servicio-integral/orden-de-servicio/extra_costos",
        name: "extra_costos",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showExtraCostos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/ExtraCostosPage"
          ),
      },

      // Por Procesar
      {
        path: "servicio-integral/orden-de-servicio/por_procesar",
        name: "por_procesar",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showPorProcesar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/PorProcesarPage"
          ),
      },

      // Canceladas
      {
        path: "servicio-integral/orden-de-servicio/canceladas",
        name: "canceladas",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showCanceladas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/CanceladasPage"
          ),
      },

      // Finalizadas
      {
        path: "servicio-integral/orden-de-servicio/finalizadas",
        name: "finalizadas",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showFinalizadas ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/serviciointegral/ordenservicio/FinalizadasPage"
          ),
      },

      // Ordenes Servicio
      {
        path: "si-finanzas/ordenes-servicio",
        name: "Órdenes Servicio",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showOrdenesDeServicio ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/OrdenesServicioPage"
          ),
      },

      // Contable / Compra
      {
        path: "si-finanzas/contable/compra",
        name: "Órdenes Servicio",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showCompra ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/contable/CompraPage"
          ),
      },

      // Contable / Vincular Costo Compra
      {
        path: "si-finanzas/contable/vincular-costo-compra",
        name: "Vincular Costo Compra",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showVincularCostoCompra ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/contable/VincularCostoCompraPage"
          ),
      },

      // Contable / Venta
      {
        path: "si-finanzas/contable/venta",
        name: "Venta",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showVenta ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/contable/VentaPage"
          ),
      },

      // Contable / Vincular Costo Venta
      {
        path: "si-finanzas/contable/vincular-costo-venta",
        name: "Vincular Costo Venta",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showVincularCostoVenta ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/contable/VincularCostoVentaPage"
          ),
      },

      // No Contable / Compra
      {
        path: "si-finanzas/no-contable/compra",
        name: "Compra",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showCompraNoContable ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/nocontable/CompraPage"
          ),
      },

      // No Contable / Vincular Costo Compra
      {
        path: "si-finanzas/no-contable/vincular-costo-compra",
        name: "Vincular Costo Compra",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showVincularCostoCompraNoContable ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/nocontable/VincularCostoCompraPage"
          ),
      },

      // No Contable / Vincular Costo Venta
      {
        path: "si-finanzas/no-contable/vincular-costo-venta",
        name: "Vincular Costo Venta",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showVincularCostoVentaNoContable ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/nocontable/VincularCostoVentaPage"
          ),
      },

      // Resumen Cliente
      {
        path: "si-finanzas/resumen-cliente",
        name: "Resumen Cliente",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showResumenCliente ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/ResumenClientePage"
          ),
      },

      // Resumen Proveedor
      {
        path: "si-finanzas/resumen-proveedor",
        name: "Resumen Proveedor",
        beforeEnter: (to, from, next) => (!validSIFinanzasRouter.showResumenProveedor ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/sifinanzas/ResumenProveedorPage"
          ),
      },

      // Shipping Instructions / Shipping Instructions Por Enviar
      {
        path: "shipping-instructions/shipping-instructions-por-enviar",
        name: "shippingInstructionsPorEnviar",
        beforeEnter: (to, from, next) => (!validShippingRouter.showShippingInstructionsPorEnviar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsPorEnviarPage"
          ),
      },

      // Shipping Instructions / Shipping Instructions Por Aprobar
      {
        path: "shipping-instructions/shipping-instructions-por-aprobar",
        name: "shippingInstructionsPorAprobar",
        beforeEnter: (to, from, next) => (!validShippingRouter.showShippingInstructionsPorAprobar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsPorAprobarPage"
          ),
      },

      // Shipping Instructions / Shipping Instructions Por Realizar
      {
        path: "shipping-instructions/shipping-instructions-por-realizar",
        name: "shippingInstructionsPorRealizar",
        beforeEnter: (to, from, next) => (!validShippingRouter.showShippingInstructionsPorRealizar ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsPorRealizarPage"
          ),
      },


      // Shipping Instructions / Shipping Instructions Enviados
      {
        path: "shipping-instructions/shipping-instructions-enviados",
        name: "shippingInstructionsEnviados",
        beforeEnter: (to, from, next) => (!validShippingRouter.showShippingInstructionsEnviados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsEnviadosPage"
          ),
      },

      // Shipping Instructions / Shipping Instructions Confirmados
      {
        path: "shipping-instructions/shipping-instructions-confirmados",
        name: "shippingInstructionsConfirmados",
        beforeEnter: (to, from, next) => (!validShippingRouter.showShippingInstructionsConfirmados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsConfirmadosPage"
          ),
      },

      // Shipping Instructions / Shipping Instructions Rechazados
      {
        path: "shipping-instructions/shipping-instructions-rechazados",
        name: "shippingInstructionsRechazados",
        beforeEnter: (to, from, next) => (!validShippingRouter.showShippingInstructionsRechazados ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsRechazadosPage"
          ),
      },

      // Shipping Instructions / Templates
      {
        path: "shipping-instructions/shipping-instructions-templates",
        name: "shippingInstructionsTemplates",
        beforeEnter: (to, from, next) => (!validShippingRouter.showTemplates ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsTemplatesPage"
          ),
      },
      // Shipping Instructions / Reportes
      {
        path: "shipping-instructions/shipping-instructions-reportes",
        name: "shippingInstructionsReportes",
        beforeEnter: (to, from, next) => (!validShippingRouter.showReportes ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/shippinginstructions/ShippingInstructionsReportePage"
          ),
      },
      //liquidaciones
      {
        path: "liquidaciones/preliminares",
        name: "liquidaciones",
        //beforeEnter: (to, from, next) => (!validAdministracionRouter.showLiquidaciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/liquidations/LiquidationsPreliminariesPage.vue"
          ),
      },
      {
        path: "liquidaciones/finales/:tab?",
        name: "liquidaciones",
        //beforeEnter: (to, from, next) => (!validAdministracionRouter.showLiquidaciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/liquidations/LiquidationsFinalsPage.vue"
          ),
      },
      {
        path: "liquidaciones/glosas",
        name: "liquidaciones",
        //beforeEnter: (to, from, next) => (!validAdministracionRouter.showLiquidaciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/liquidations/LiquidationsGlossesPage.vue"
          ),
      },
      {
        path: "liquidaciones/importador-de-contenedores",
        name: "liquidaciones",
        //beforeEnter: (to, from, next) => (!validAdministracionRouter.showLiquidaciones ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/liquidations/LiquidationsContainersImporterPage.vue"
          ),
      },



      // Administración tarifados
      {
        path: "tarifado/tarifas_proveedores_Terrestres",
        name: "tarifasProveedoresTerrestres",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasProveedoresTerrestres ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "proveedoresTerrestres" */ "../views/serviciosLogisticos/tarifas/ProveedoresTerrestresPage.vue"
          ),
      },
      {
        path: "tarifado/tarifas_proveedores_Documentales",
        name: "tarifasProveedoresDocumentales",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasProveedoresDocumentales ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "proveedoresDocumentales" */ "../views/serviciosLogisticos/tarifas/ProveedoresDocumentalesPage.vue"
          ),
      },
      {
        path: "tarifado/proveedores_extra_costos",
        name: "proveedoresExtraCostos",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasProveedoresExtraCosto ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "proveedoresExtraCostos" */ "../views/serviciosLogisticos/tarifas/ProveedoresExtraCostosPage.vue"
          ),
      },
      {
        path: "tarifado/clientes_Terrestres",
        name: "clientesTerrestres",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasClientesTerrestres ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "clientesTerrestres" */ "../views/serviciosLogisticos/tarifas/ClientesTerrestresPage.vue"
          ),
      },
      {
        path: "tarifado/tarifas_clientes_Documentales",
        name: "tarifasClientesDocumentales",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasClientesDocumentales ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "clientesDocumentales" */ "../views/serviciosLogisticos/tarifas/ClientesDocumentalesPage.vue"
          ),
      },
      {
        path: "tarifado/clientes_extra_costos",
        name: "clientExtraCost",
        beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasClientesExtraCostos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "clientesTerrestres" */ "../views/serviciosLogisticos/tarifas/ClientesExtraCostosPage.vue"
          ),
      },

      {
        path: "servicios_logisticos/liquidaciones_extra_costos/glosas",
        name: "liquidacionesExtraCostosGlosas",
        // beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasClientesExtraCostos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "liquidacionesExtraCostosGlosas" */ "../views/serviciosLogisticos/liquidacion_extra_costo/GlosasPage.vue"
          ),
      },
      {
        path: "servicios_logisticos/liquidaciones_extra_costos/liquidaciones_preliminares",
        name: "liquidacionesExtraCostosLiquidacionesPreliminares",
        // beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasClientesExtraCostos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "liquidacionesExtraCostosLiquidacionesPreliminares" */ "../views/serviciosLogisticos/liquidacion_extra_costo/LiquidacionesPreliminaresPage.vue"
          ),
      },
      {
        path: "servicios_logisticos/liquidaciones_extra_costos/liquidaciones_finales",
        name: "liquidacionesExtraCostosLiquidacionesFinales",
        // beforeEnter: (to, from, next) => (!validServicioIntegralRouter.showTarifasClientesExtraCostos ? next('/') : next()),
        component: () =>
          import(
            /* webpackChunkName: "liquidacionesExtraCostosLiquidacionesFinales" */ "../views/serviciosLogisticos/liquidacion_extra_costo/LiquidacionesFinalesPage.vue"
          ),
      },
      //tracking
      {
        path: "lineas/tracking_bookings",
        name: "TrackingBookings",
        component: () =>
          import("../views/tracking/TrackingPage.vue"),
      },

    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "../views/login"),
  },
  {
    path: "*",
    component: () =>
      import(/* webpackChunkName: "noFound" */ "../views/notFoundPage"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
